<template>
  <vt-grid
    class="ps-grid"
    :grid-options="gridOptions"
    :column-defs="columnDefs"
    :row-data="rowData"
    component-code="uicomponent.registry.subrequestgrid"
  />
</template>

<script>

import Vue from 'vue'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import VtGrid from '@/components/VtGrid/VtGrid'
import registryRequestResource from '@/modules/RegistryModule/services/registryRequestResource'
import { AgGridColumnType, AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default Vue.extend({
    name: 'MyDetailCellRenderer',
    components: {
        VtGrid
    },
    data() {
        return {
            gridApi: null,
            rowData: []
        }
    },
    computed: {
        gridOptions() {
            return {
                pagination: false,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                floatingFilter: false,
                sideBar: gridSideBarConfig,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: params => { this.onGridReady(params) }
            }
        },
        columnDefs() {
            const columns = [
                { type: AgGridColumnType.TEXT, field: 'surExternalId', headerName: this.$tc('registry.requestGrid.subGrid.sampleId'), onCellClicked: this.onIdClicked, onCellDoubleClicked: this.onIdDoubleClicked },
                { type: AgGridColumnType.TEXT, field: 'topographicCode.description', headerName: this.$tc('registry.requestGrid.subGrid.location') },
                { type: AgGridColumnType.TEXT, field: 'sampleType.description', headerName: this.$tc('registry.requestGrid.subGrid.sampleType') },
                { type: AgGridColumnType.TEXT, field: 'procedure.description', headerName: this.$tc('registry.requestGrid.subGrid.procedure') },
                { type: AgGridColumnType.TEXT, field: 'mostLikelyMorphologicCode.description', headerName: this.$tc('registry.requestGrid.subGrid.mostLikelyDiagnosis') },
                { type: AgGridColumnType.DATETIME, field: 'surSamplingDate', headerName: this.$tc('registry.requestGrid.subGrid.samplingDate') }
            ]
            if (this.masterDetail) {
                columns.unshift({ type: AgGridColumnType.MASTER_DETAIL })
            }
            return columns
        },
        requestData() {
            return this.params.data
        }
    },
    methods: {
        editCase() {
            if (this.params.data.caseStudy) {
                this.$router.push({ name: 'registryEditCase', params: { id: this.params.data.caseStudy.casId } })
            }
        },
        onGridReady({ api }) {
            this.gridApi = api
            this.getRowData()
            api.setDomLayout('autoHeight')
            api.sizeColumnsToFit()
        },
        async getRowData() {
            this.rowData =
                await this.$_toCallSecure(
                    registryRequestResource.getSubRequests(
                        this.requestData.laboratory.labId,
                        this.requestData.id))
        },
        getContextMenuItems(params) {
            if (params?.node) {
                this.request = params.node.data
                return [{
                    name: this.$tc('global.export'),
                    subMenu: [
                        {
                            name: this.$tc('global.contextMenu.excel'),
                            action: () => {
                                const onlySelected = !!(params.api.getSelectedNodes().length)
                                params.api.exportDataAsExcel({
                                    onlySelected,
                                    processCellCallback: ({ column, value }) =>
                                        this.$_processCellOutput(column, value)
                                })
                            }
                        }
                    ]
                }]
            }
            return []
        },
        registerIncident() {
            this.$eventHub.$emit('showIncidentModal', this.params.data)
        },
        processRequest() {
            this.$eventHub.$emit('showProcessModal', this.params.data)
        },
        cancelRequest() {
            this.$eventHub.$emit('showCancelModal', this.params.data)
        },
        returnRequest() {
            this.$eventHub.$emit('showReturnModal', this.params.data)
        }
    }
})

</script>

<style scoped>

.ps-grid{
  padding: 25px;
}
  .page_renderer {
    height: 100px;
    text-align:right;
  }
  .button_row {
    margin: 1% 0 1.5% 0;
  }

  .button_detail {
    margin-right: 1%;
  }
</style>
